<nav id='top-navbar' class="navbar navbar-toggleable-sm navbar-expand-sm navbar-dark sticky-top scheme-bg-dark me-0">
    <div class="container-fluid">
        <!-- Logo -->
        <div class="navbar-brand">
            <shared-logo [link]="'/projects'"></shared-logo>
        </div>

        <!-- Profile Picture -->
        <shared-profile-picture></shared-profile-picture>
    </div>
</nav>

<main class="error-page-main d-flex align-items-center justify-content-center">
    <div class="error-card card shadow-sm border-0 text-center p-4 p-md-5">
        <div class="icon-badge icon-badge--{{ iconTone }} mx-auto mb-4">
            <i class="fa {{ iconClass }}"></i>
        </div>

        <h1 class="h3 fw-semibold mb-2">{{ title }}</h1>
        <p class="text-muted mb-2">{{ lead }}</p>
        <p class="mb-4">{{ body }}</p>

        <div class="d-grid gap-2">
            @if (hasPrimaryAction) {
                <button type="button" class="btn btn-primary btn-lg"
                    (click)="primaryAction()"
                    [disabled]="isOpening">
                    @if (isOpening) {
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <span>Working…</span>
                    } @else {
                        <span>{{ primaryActionLabel }}</span>
                    }
                </button>
            }
            @if (hasSecondaryAction) {
                <button type="button" class="btn btn-link text-muted" (click)="secondaryAction()">
                    Sign out
                </button>
            }
        </div>

        @if (errorCode === '402') {
            <p class="small text-muted mt-4 mb-0">
                Not the right person to handle billing? Ask your organization admin,
                or email <a href="mailto:support@kartorium.com">support&#64;kartorium.com</a>.
            </p>
        }
    </div>
</main>
